module.exports = __webpack_public_path__ + "img/adzuna.3d9b1c5a.svg";